import { render, staticRenderFns } from "./pubRate.vue?vue&type=template&id=6cb123d2&scoped=true&"
import script from "./pubRate.vue?vue&type=script&lang=js&"
export * from "./pubRate.vue?vue&type=script&lang=js&"
import style0 from "./pubRate.vue?vue&type=style&index=0&id=6cb123d2&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb123d2",
  null
  
)

export default component.exports